@for (article of items(); track $index) {
  <div class="row pt-3 align-items-center" [ngClass]="{ 'mb-4': !$last }">
    <div class="col-md-6">
      <div class="toc-image">
        <a [routerLink]="['/articulo', article.slug]">
          <img
            class="img-zoomable"
            [src]="article.image | assetFormatter"
            alt=""
          />
        </a>
      </div>
    </div>
    <div class="col-md-6">
      <div class="px-md-4 py-3 py-md-0">
        @if (article.subject) {
          <span class="category-badge mb-3">
            {{ article.subject.name }}
          </span>
        }
        <h4>
          <a [routerLink]="['/articulo', article.slug]">
            {{ article.title }}
          </a>
        </h4>
        @if (article.author) {
          <a
            class="author-label"
            [routerLink]="['/buscar']"
            [queryParams]="{ a: article.author?.id }"
          >
            Por
            {{ article.author.name + " " + article.author.surname }}
          </a>
        }
      </div>
    </div>
  </div>
}
